module.exports = __webpack_public_path__ + "img/vapo.c3407c40.png";